import MappingRisksTypes from "ContainersForm/MappingRisk/types"

const INITIAL_STATE = {
  mappingHistory: [],
}

const mappingRiskReducer = (state = INITIAL_STATE, { type, payload }) => {
  switch (type) {
    case MappingRisksTypes.GET_HISTORY_MAPPING_SUCCESS:
      return {
        ...state,
        mappingHistory: payload,
      }
    default:
      return state
  }
}

export default mappingRiskReducer
